import {RoleId, UserId} from "platformed-client/types";
import {invalidateQueries, q} from "../state";
import {platformedClient} from ".";

export async function list() {
  return await platformedClient.internalRequest("get", "/region/{region}/api/roles", {path: {}});
}

export async function listMembers(roleId: RoleId) {
  return await platformedClient.internalRequest("get", "/region/{region}/api/roles/{role_id}/members", {
    path: {role_id: roleId},
  });
}

export async function addMember(roleId: RoleId, userId: UserId) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/roles/{role_id}/members", {
    path: {role_id: roleId},
    body: userId,
  });
  await invalidateQueries([q.roles.filter(), q.roleMembers.filter(roleId), q.accountUsers.filter()]);
  return res;
}

export async function removeMember(roleId: RoleId, userId: UserId) {
  const res = await platformedClient.internalRequest(
    "delete",
    "/region/{region}/api/roles/{role_id}/members/{user_id}",
    {path: {role_id: roleId, user_id: userId}},
  );
  await invalidateQueries([q.roles.filter(), q.roleMembers.filter(roleId), q.accountUsers.filter()]);
  return res;
}
